import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { defaultFilters } from '@views/Risk/risk.utils';

const defaultRiskFilters = defaultFilters('finding');

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/risk/')({
  validateSearch: zodValidator(withDefaults(schema.RISK, defaultRiskFilters)),
  search: {
    middlewares: [stripSearchParams(defaultRiskFilters)],
  },
});
